.root {
  text-transform: none;

  &[data-variant="default"] {
    background-color: var(--mantine-color-secondary-1);
    color: var(--mantine-color-secondary-7);
    border: none;
  }

  &[data-variant="light-gray"] {
    background-color: light-dark(
      var(--mantine-color-primaryDark-2),
      var(--mantine-color-secondary-6)
    );
    color: light-dark(var(--mantine-color-primaryDark-8), var(--mantine-color-secondary-0));
    border: none;
  }

  &[data-variant="light-green"] {
    background-color: var(--mantine-color-success-1);
    color: light-dark(var(--mantine-color-success-9), var(--mantine-color-success-9));
    border: none;
  }

  &[data-variant="light-red"] {
    background-color: var(--mantine-color-danger-1);
    color: light-dark(var(--mantine-color-danger-7), var(--mantine-color-danger-7));
    border: none;
  }

  &[data-variant="light-yellow"] {
    background-color: var(--mantine-color-yellow-1);
    color: light-dark(var(--mantine-color-yellow-7), var(--mantine-color-yellow-7));
    border: none;
  }
}
